import React, { useContext, useState } from "react";

export const useFlow = () => {
  const [flowData, setFlowData] = useState({
    isChanged: false,
    project: ()=>({}),
    get: ()=>([]),
    fit: ()=>{},
  });
  return { flowData, setFlowData };
}

export const FlowContext = React.createContext(useFlow); 

export const useFlowContext = () => { 
  return useContext(FlowContext); 
};

export const FlowProvider = ({ children }) => {
  const flow = useFlow();
  return (
    <FlowContext.Provider value={flow}>
      {children}
    </FlowContext.Provider>
  );
};
